module.exports = __webpack_public_path__ + "img/generic.43e51a4b.svg";